import React from "react";

import { BrowserRouter, Route, Routes } from "react-router-dom";

import AdminLayout from "~/admin/AdminLayout";
import ErrorsLayout from "~/layouts/errorsLayout/ErrorsLayout";
import AdminPublicLayout from "~/admin/layouts/publicLayout/AdminPublicLayout";
import ScrollToTop from "~/components/ScrollToTop";

import AdminRoutes from "./AdminRoutes";
import CommonRoutes from "./CommonRoutes";
import LandingPagesRoutes from "./LandingPageRoutes";
import LandingPageLayout from "~/landingPage/LandingPageLayout";

export default function Router() {
  const renderRoute = (route, prefix = null) => {
    let Component = route.component;

    return (
      <Route
        key={`${prefix || "*"}/${route.path}`}
        path={`${route.path}`}
        element={<Component />}
      />
    );
  };

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/admin" element={<AdminLayout />}>
          {AdminRoutes.private.map((route) => renderRoute(route))}
        </Route>

        <Route path="/admin" element={<AdminPublicLayout />}>
          {AdminRoutes.public.map((route) => renderRoute(route))}
        </Route>

        <Route path="" element={<LandingPageLayout />}>
          {LandingPagesRoutes.public.map((route) => renderRoute(route))}
        </Route>

        <Route path="*" element={<ErrorsLayout />}>
          {CommonRoutes.map((route) => renderRoute(route))}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
